(function ($) {
  'use strict';

  /**
   * Check if an element is in view or not
   */

  $.fn.isInViewport = function ( args ) {
    args = $.extend({
      // Offset top & bottom
      block_offset: 0,
    }, args );
    var $this = $(this);
    var $window = $(window);
    var block_offset = args['block_offset'];
    var elementTop = $this.offset().top - block_offset;
    var elementBottom = elementTop + $this.outerHeight() + ( block_offset * 2 );
    var viewportTop = $window.scrollTop();
    var viewportBottom = viewportTop + $window.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

})(jQuery);
